const DEFAULT_BRAND_KEY = "default";
const DEFAULT_LOGIN_ROUTE_NAME = "Login";
const CLIENT_LOGIN_ROUTE_NAME = "LoginCliente";
const PASSWORD_RECOVERY_ROUTE_NAME = "Esqueceu.senha";
const WHITE_LABEL_STORAGE_KEY = "cajupe.whiteLabelBrand";

const defaultPublicLogo = require("@/assets/Cajupe_simples.png");
const defaultAuthLogo = require("@/assets/cajupe-logo.png");
const preserveLogo = require("@/assets/img/logos/clientes/preserve-50-anos.webp");
const preserveCover = require("@/assets/img/white-label/preserve-cover.webp");
const unicaLogo = require("@/assets/img/logos/clientes/unica-logo.webp");
const unicaCover = require("@/assets/img/white-label/unica-cover.webp");
const exemplarLogo = require("@/assets/img/logos/clientes/exemplar-service.svg");
const exemplarCover = require("@/assets/img/white-label/exemplar-cover.jpg");

const faviconBasePath = process.env.BASE_URL || "/";

const BRAND_CONFIGS = {
  default: {
    key: DEFAULT_BRAND_KEY,
    i18nKey: "publicPages.brands.default",
    keyword: "",
    displayName: "Cajupe®",
    shortName: "Cajupe",
    publicLogo: defaultPublicLogo,
    authLogo: defaultAuthLogo,
    logoAlt: "Cajupe",
    landingButtonColor: "#a11d16",
    landingAccentColor: "#f06445",
    landingVariant: "product-suite",
    authButtonColor: "#a11d16",
    authAccentColor: "#f06445",
    authLogoWidth: 200,
    dashboardPrimaryColor: "#a11d16",
    dashboardPrimaryGradientEnd: "#d4432c",
    dashboardAccentColor: "#f06445",
    documentTitle: "Cajupe",
    faviconPath: `${faviconBasePath}favicon.ico`,
    socialImagePath: `${faviconBasePath}og-cajupe.png`,
  },
  preserve: {
    key: "preserve",
    i18nKey: "publicPages.brands.preserve",
    keyword: "preserve",
    displayName: "Preserve",
    shortName: "Preserve",
    publicLogo: preserveLogo,
    authLogo: preserveLogo,
    logoAlt: "Grupo Preserve Liserve — 50 anos",
    landingButtonColor: "#d5a928",
    landingAccentColor: "#d5a928",
    landingVariant: "immersive-cover",
    landingPanelVariant: "dark-legacy",
    landingCover: preserveCover,
    authButtonColor: "#253077",
    authAccentColor: "#d5a928",
    authLogoWidth: 180,
    loginVariant: "secure-cover",
    dashboardPrimaryColor: "#253077",
    dashboardPrimaryGradientEnd: "#4653a4",
    dashboardAccentColor: "#d5a928",
    documentTitle: "Preserve",
    faviconPath: `${faviconBasePath}preserve.ico`,
    socialImagePath: `${faviconBasePath}og-preserve.png`,
  },
  unica: {
    key: "unica",
    i18nKey: "publicPages.brands.unica",
    keyword: "facilitiesunica",
    displayName: "Única",
    shortName: "Única",
    publicLogo: unicaLogo,
    authLogo: unicaLogo,
    logoAlt: "Única",
    landingButtonColor: "#103f73",
    landingAccentColor: "#8aa7d4",
    landingVariant: "immersive-cover",
    landingCover: unicaCover,
    authButtonColor: "#103f73",
    authAccentColor: "#42639d",
    authLogoWidth: 280,
    loginVariant: "editorial-cover",
    dashboardPrimaryColor: "#103f73",
    dashboardPrimaryGradientEnd: "#42639d",
    dashboardAccentColor: "#42639d",
    documentTitle: "Única",
    faviconPath: `${faviconBasePath}unica.ico`,
    socialImagePath: `${faviconBasePath}og-unica.png`,
  },
  exemplar: {
    key: "exemplar",
    i18nKey: "publicPages.brands.exemplar",
    keyword: "exemplarsvc",
    displayName: "Exemplar Service",
    shortName: "Exemplar",
    publicLogo: exemplarLogo,
    authLogo: exemplarLogo,
    logoAlt: "Exemplar Service",
    landingButtonColor: "#272b5c",
    landingVariant: "split-cover",
    landingCover: exemplarCover,
    authButtonColor: "#272b5c",
    authLogoWidth: 360,
    loginVariant: "editorial-cover",
    dashboardPrimaryColor: "#272b5c",
    dashboardPrimaryGradientEnd: "#414a85",
    dashboardAccentColor: "#f07f21",
    documentTitle: "Exemplar Service",
    faviconPath: `${faviconBasePath}exemplar.ico`,
    socialImagePath: `${faviconBasePath}og-exemplar.png`,
  },
};

const normalizeValue = (value = "") =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const getBrandConfig = (key) => BRAND_CONFIGS[key] || BRAND_CONFIGS.default;

const getStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

const getCurrentPath = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return normalizeValue(window.location.pathname || "");
};

const resolveBrandKey = (value = "") => {
  const normalizedValue = normalizeValue(value);

  if (normalizedValue.includes("exemplarsvc")) {
    return "exemplar";
  }

  if (
    normalizedValue.includes("facilitiesunica") ||
    normalizedValue.includes("facilities-unica")
  ) {
    return "unica";
  }

  if (
    normalizedValue.includes("preserve") ||
    normalizedValue.includes("liserve")
  ) {
    return "preserve";
  }

  return DEFAULT_BRAND_KEY;
};

export const resolveWhiteLabelBrand = (value) => {
  if (value !== undefined) {
    return getBrandConfig(resolveBrandKey(value));
  }

  if (typeof window === "undefined") {
    return BRAND_CONFIGS.default;
  }

  const currentBrand = getBrandConfig(resolveBrandKey(window.location.href));
  const storage = getStorage();
  const currentPath = getCurrentPath();
  const shouldResetStoredBrand = [
    "/",
    "/login",
    "/login_cliente",
    "/recuperar-senha",
  ].includes(currentPath);

  if (isClientWhiteLabel(currentBrand) && storage) {
    storage.setItem(WHITE_LABEL_STORAGE_KEY, currentBrand.key);
  } else if (shouldResetStoredBrand && storage) {
    storage.removeItem(WHITE_LABEL_STORAGE_KEY);
  }

  return currentBrand;
};

export const resolveWhiteLabelBrandFromTenantName = (tenantName = "") => {
  const normalizedTenantName = normalizeValue(tenantName);

  if (
    normalizedTenantName.includes("exemplarsvc") ||
    normalizedTenantName.includes("exemplar service") ||
    normalizedTenantName.includes("exemplar")
  ) {
    return BRAND_CONFIGS.exemplar;
  }

  if (
    normalizedTenantName.includes("facilitiesunica") ||
    normalizedTenantName.includes("facilities unica") ||
    normalizedTenantName.includes("unica")
  ) {
    return BRAND_CONFIGS.unica;
  }

  if (
    normalizedTenantName.includes("preserve") ||
    normalizedTenantName.includes("liserve")
  ) {
    return BRAND_CONFIGS.preserve;
  }

  return BRAND_CONFIGS.default;
};

export const isClientWhiteLabel = (brand) =>
  Boolean(brand && brand.key !== DEFAULT_BRAND_KEY);

export const resolveAppWhiteLabelBrand = () => {
  const currentBrand = resolveWhiteLabelBrand();
  if (isClientWhiteLabel(currentBrand)) {
    return currentBrand;
  }

  const storage = getStorage();
  if (!storage) {
    return BRAND_CONFIGS.default;
  }

  return getBrandConfig(storage.getItem(WHITE_LABEL_STORAGE_KEY));
};

export const getLoginRouteByBrand = (brand) => {
  if (isClientWhiteLabel(brand)) {
    return {
      name: CLIENT_LOGIN_ROUTE_NAME,
      query: {
        cliente: brand.keyword,
      },
    };
  }

  return {
    name: DEFAULT_LOGIN_ROUTE_NAME,
  };
};

export const getPasswordRecoveryRouteByBrand = (brand) => {
  if (isClientWhiteLabel(brand)) {
    return {
      name: PASSWORD_RECOVERY_ROUTE_NAME,
      query: {
        cliente: brand.keyword,
      },
    };
  }

  return {
    name: PASSWORD_RECOVERY_ROUTE_NAME,
  };
};

export const getLocalizedWhiteLabelText = (brand, field, i18n) => {
  const translationKey = brand?.i18nKey ? `${brand.i18nKey}.${field}` : null;

  if (
    translationKey &&
    i18n &&
    typeof i18n.te === "function" &&
    i18n.te(translationKey)
  ) {
    return i18n.t(translationKey);
  }

  return brand?.[field] || "";
};

export const applyWhiteLabelDocumentBrand = (value, i18n) => {
  if (typeof document === "undefined") {
    return BRAND_CONFIGS.default;
  }

  const brand = resolveWhiteLabelBrand(value);
  document.title = brand.documentTitle;

  const setMeta = (attribute, key, content) => {
    let meta = document.querySelector(`meta[${attribute}='${key}']`);

    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute(attribute, key);
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", content);
  };

  let iconLink = document.querySelector("link[rel='icon']");
  if (!iconLink) {
    iconLink = document.createElement("link");
    iconLink.rel = "icon";
    document.head.appendChild(iconLink);
  }

  iconLink.href = brand.faviconPath;

  let touchIconLink = document.querySelector("link[rel='apple-touch-icon']");
  if (!touchIconLink) {
    touchIconLink = document.createElement("link");
    touchIconLink.rel = "apple-touch-icon";
    document.head.appendChild(touchIconLink);
  }

  touchIconLink.href = brand.faviconPath;

  const metaDescription = getLocalizedWhiteLabelText(
    brand,
    "metaDescription",
    i18n
  );

  setMeta("name", "description", metaDescription);
  setMeta("property", "og:title", brand.documentTitle);
  setMeta("property", "og:site_name", brand.documentTitle);
  setMeta("property", "og:description", metaDescription);
  setMeta("property", "og:image", brand.socialImagePath);
  setMeta("name", "twitter:title", brand.documentTitle);
  setMeta("name", "twitter:description", metaDescription);
  setMeta("name", "twitter:image", brand.socialImagePath);

  return brand;
};
